import SharedBaseModel from '@/shared/models/BaseModel'

/**
 * Esta classe deve ser usada como pai para todos os modelos deste frontend
 */
export default class BaseModel extends SharedBaseModel {

}